export default __webpack_public_path__ + "static/media/thumbnail-light.9709f43e.webp";